import { createApi } from "@reduxjs/toolkit/query/react";

import apiConfig from "configs/apiConfig";
import { REDUCER_PATHS } from "store/config";
import { transformResponseHandler } from "utils/transformResponseHandler";

import { customFetchBase } from ".";

const questionnaireApi = createApi({
  reducerPath: REDUCER_PATHS.OUESTIONNAIRE,
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    addQuestion: builder.mutation({
      query: (data) => ({
        url: apiConfig.QUESTION_MANAGEMANT,
        body: data,
        method: "POST",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    questionListing: builder.query({
      query: (data) => ({
        url: `${apiConfig.QUESTION_MANAGEMANT}/listing?type=${data.type}`,
        method: "GET",
      }),
      providesTags: ["questionListing"],
    }),
    deleteQuestion: builder.mutation({
      query: (data) => ({
        url: apiConfig.QUESTION_MANAGEMANT,
        body: data,
        method: "DELETE",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    editQuestion: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.QUESTION_MANAGEMANT}/${data?.questionId}`,
        body: data.formData,
        method: "PUT",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    questionDetails: builder.query({
      query: (data) => ({
        url: `${apiConfig.QUESTION_MANAGEMANT}/details/${data?.questionId}`,
        method: "GET",
      }),
      providesTags: [""],
    }),
    questionDetailSwap: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.QUESTION_MANAGEMANT}/swap`,
        body: data,
        method: "PATCH",
      }),
      invalidatesTags: ["questionListing"],
    }),
  }),
});
export const {
  useAddQuestionMutation,
  useLazyQuestionListingQuery,
  useDeleteQuestionMutation,
  useLazyQuestionDetailsQuery,
  useEditQuestionMutation,
  useQuestionDetailSwapMutation,
} = questionnaireApi;

export default questionnaireApi;
